import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Icon } from 'antd';

import { ModalSto } from 'components/sto';

const EmailInfoModal = (props) => (
    <ModalSto okText="general.ok" onOk={props.onOk} visible={props.visible}>
        <React.Fragment>
            <div className="tooltip">
                <Icon type="question-circle" />
                <div className="tooltip-details">
                    <h2 className="pop-up-title">
                        <FormattedMessage id="popup.email.title" />
                    </h2>
                    <p>
                        <FormattedMessage id="popup.email.text" />
                    </p>
                </div>
            </div>
        </React.Fragment>
    </ModalSto>
);

export default EmailInfoModal;
